import request from '@/utils/request'
/** 车队用途类型 */
export function getOrderPurpose(data) {
  return request({
    url: '/alp/order/purpose',
    data
  })
}
/** 申请部门 （获取车队部门）*/
export function getCompany(data) {
  return request({
    url: '/alp/order/company',
    data
  })
}
/** 获取线下订单来源 */
export function validList(data) {
  return request({
    url: 'alp/channel/validList',
    data
  })
}
/** 线下免费订单 */
export function getOfflineList(data) {
  return request({
    url: '/alp/offline_car/list',
    data
  })
}
/** 线下有效订单 */
export function getValidList(data) {
  return request({
    url: '/alp/offline_car/validList',
    data
  })
}
/** 线下无效订单 */
export function getInvalidList(data) {
  return request({
    url: '/alp/offline_car/invalidList',
    data
  })
}
/** 获取录入列表信息 */
export function getAddInfo(data) {
  return request({
    url: 'alp/offline_car/packageInfo',
    data
  })
}
/** 线下部门订单录入/线下免费订单录入 */
export function getAdd(data, free) {
  let _url = free ? 'alp/offline_car/addHq' : 'alp/offline_car/add'
  return request({
    url: _url,
    data
  })
}
/** 线下订单详情 */
export function getDetail(data) {
  return request({
    url: 'alp/offline_car/detail',
    data
  })
}
/** 指定车队，获取车牌号 */
export function getLicense(data) {
  return request({
    url: 'alp/offline_car/getLicense',
    data
  })
}
/** 调度信息更新 */
export function getDispatch(data) {
  return request({
    url: 'alp/offline_car/dispatch',
    data
  })
}
/** 客人信息更新 */
export function updateTourist(data) {
  return request({
    url: 'alp/offline_car/updateTourist',
    data
  })
}
/** 车队行驶公里数列表 */
export function getTravellingList(data) {
  return request({
    url: '/alp/car_mileage/list',
    data
  })
}
/** 录入行驶公里数 */
export function inputKm(data) {
  return request({
    url: '/alp/car_mileage/add',
    data
  })
}
/** 录入车辆损坏情况接口数 */
export function inputCarRepair(data) {
  return request({
    url: '/alp/car_repair/add',
    data
  })
}
/** 车辆损坏情况列表接口 */
export function getRepairList(data) {
  return request({
    url: '/alp/car_repair/list',
    data
  })
}
/** 车辆损坏情况详情 */
export function getRepairDetail(data) {
  return request({
    url: '/alp/car_repair/detail',
    data
  })
}
/** 车辆损坏情况详情修改 */
export function getRepairUpdate(data) {
  return request({
    url: '/alp/car_repair/modify',
    data
  })
}
/** 车辆保养列表接口 */
export function getMaintainList(data) {
  return request({
    url: '/alp/car_maintain/list',
    data
  })
}
/** 车辆保养详情接口 */
export function getMaintainDetail(data) {
  return request({
    url: '/alp/car_maintain/detail',
    data
  })
}
/** 车辆保养详情修改 */
export function getMaintainUpdate(data) {
  return request({
    url: '/alp/car_maintain/modify',
    data
  })
}
/** 车辆数据日报列表接口 */
export function getDailyList(data) {
  return request({
    url: '/alp/car_daily/list',
    data
  })
}
/** 车辆数据日报列表导出接口 */
export function exportDailyList(data) {
  return request({
    url: '/alp/car_daily/export',
    data
  })
}
/** 车型车牌列表 */
export function getLicenseList(data) {
  return request({
    url: '/alp/car/plate_list',
    data
  })
}
/** 司机数据接口 */
export function getDriverList(data) {
  return request({
    url: '/alp/car_driver/list',
    data
  })
}
/** 司机数据日报接口 */
export function getDriverDailyList(data) {
  return request({
    url: '/alp/car_driver_daily/list',
    data
  })
}
/** 司机数据日报导出接口 */
export function exportDriverDaily(data) {
  return request({
    url: '/alp/car_driver_daily/export',
    data
  })
}
/** 月结算报表数据接口 */
export function getMonthDaily(data) {
  return request({
    url: '/alp/car_settle/list',
    data
  })
}
/** 职员取消订单 */
export function carCancel(data) {
  return request({
    url: 'alp/offline_car/cancel',
    data
  })
}
/** 职员取消订单 */
export function carCancel2(data) {
  return request({
    url: 'alp/offline_car/cancelApprove',
    data
  })
}
/** 订单调度审核 */
export function approveDispatch(data) {
  return request({
    url: 'alp/offline_car/approveDispatch',
    data
  })
}
/** 部门领导审核订单 */
export function approve(data) {
  return request({
    url: 'alp/offline_car/approve',
    data
  })
}
/** 客人接送信息更新 */
export function delayInfo(data) {
  return request({
    url: 'alp/offline_car/delayInfo',
    data
  })
}
/** 超出时间、范围信息录入 */
export function overFee(data) {
  return request({
    url: 'alp/offline_car/overFee',
    data
  })
}
/** 车辆用途 */
export function getPurpose(data) {
  return request({
    url: 'alp/offline_car/purposePackage',
    data
  })
}

/** 套餐信息 */
export function getPackage(data) {
  return request({
    url: 'alp/offline_car/package',
    data
  })
}
/** 维修记录 */
export function getRepairRecord(data) {
  return request({
    url: 'alp/car_repair/record',
    data
  })
}
/** 保养记录 */
export function getMaintainRecord(data) {
  return request({
    url: 'alp/car_maintain/record',
    data
  })
}
/** 车型列表 */
export function getCarList() {
  return request({
    url: '/alp/car/list'
  })
}
/** 车型车牌列表,车辆列表接口 */
export function getCarLicense(data) {
  return request({
    url: '/alp/car_license/list',
    data
  })
}
/** 车型车牌列表,车辆列表接口 */
export function modifyStatus(data) {
  return request({
    url: 'alp/car_license/modify_status',
    data
  })
}
/** 月对账单接口 */
export function monthlyAccount(data) {
  return request({
    url: 'alp/car_settle/account',
    data
  })
}
/** 月对账单 结算接口 */
export function settle(data) {
  return request({
    url: 'alp/car_settle/modify_status',
    data
  })
}
/** 获取全部车型和车牌 */
export function getAllLicense(data) {
  return request({
    url: 'alp/car_license/get_car_license',
    data
  })
}
/** 车队司机添加 */
export function addDriver(data) {
  return request({
    url: 'alp/car_driver/add',
    data
  })
}
/** 车队司机修改 */
export function modifyDriver(data) {
  return request({
    url: 'alp/car_driver/modify',
    data
  })
}
/** 车队司机删除 */
export function removeDriver(data) {
  return request({
    url: 'alp/car_driver/remove',
    data
  })
}
/** 车队司机详情 */
export function detailDriver(data) {
  return request({
    url: '/alp/car_driver/detail',
    data
  })
}
/** 车辆使用图 */
export function getCarUseList(data) {
  return request({
    url: 'alp/car_use/list',
    data
  })
}
/** 车辆添加 */
export function addCarLicense(data) {
  return request({
    url: 'alp/car_license/add',
    data
  })
}
/** 车辆修改 */
export function modifyCarLicense(data) {
  return request({
    url: 'alp/car_license/modify',
    data
  })
}
/** 车辆详情 */
export function detailCarLicense(data) {
  return request({
    url: 'alp/car_license/detail',
    data
  })
}
/** 车辆删除 */
export function delCarLicense(data) {
  return request({
    url: 'alp/car_license/change_status',
    data
  })
}
/** 获取行驶公里数详情 */
export function carMileageDetail(data) {
  return request({
    url: 'alp/car_mileage/detail',
    data
  })
}
/** 保存修改行驶公里数 */
export function carMileageModify(data) {
  return request({
    url: 'alp/car_mileage/modify',
    data
  })
}

